<template>
  <div
    @keydown.esc.prevent="$emit('changeVisibility')"
    class="fixed z-10 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="
        flex
        items-end
        justify-center
        min-h-screen
        pt-4
        px-4
        pb-20
        text-center
        sm:block
        sm:p-0
      "
    >
      <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
      <div
        @click="$emit('changeVisibility')"
        class="fixed inset-0 bg-gray-700 bg-opacity-60 transition-opacity"
        aria-hidden="true"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >

      <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
      <div
        class="
          inline-block
          align-bottom
          dark:bg-gray-800
          bg-gray-50
          rounded-lg
          text-left
          overflow-hidden
          shadow-xl
          transform
          transition-all
          sm:my-8
          sm:align-middle
          w-3/4
        "
      >
        <div
          class="
            dark:bg-gray-900
            bg-gray-50
            px-4
            pt-5
            pb-4
            sm:p-6
            sm:pb-4
            group
          "
        >
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3
              class="
                text-2xl
                leading-6
                font-medium
                dark:text-gray-300
                text-gray-900
              "
              id="modal-title"
            >
              Selecionar imagem de perfil
            </h3>
            <div class="mt-2">
              <p class="text-sm text-gray-500 dark:text-gray-400">
                Importe um foto.
              </p>
              <div v-show="!selectedFile"
                class="
                  w-full
                  h-52
                  border-gray-400
                  dark:border-gray-600
                  border-2 border-dashed
                  text-center
                  mt-4
                  flex flex-col
                  select-none
                  cursor-pointer
                  content-center
                  transition-colors
                  duration-300
                  hover:bg-gray-800
                "
              >
                <input
                  type="file"
                  class="bg-blue-300 h-full opacity-0 cursor-pointer"
                  @change="onChange"
                  ref="imageInput"
                  accept=".jpg,.jpeg,.png"
                />
                <div class="-mt-36 text-gray-800 dark:text-gray-500">
                  <span
                    class="
                      material-icons-outlined
                      group-hover:animate-bounce
                      text-3xl
                    "
                  >
                    add_circle_outline
                  </span>
                  <p class="text-lg">Arraste e solte arquivo ou clique aqui</p>
                </div>
              </div>
                <div v-show="selectedFile" class="w-64 max-h-72 h-auto object-fill mx-auto">
                    <img ref="img" class="block max-w-full" :src="imageSrc"/>
                    <p @click="clearFile(); imageInput.click()" class="text-center mt-6 text-indigo-200 hover:text-indigo-500 btn cursor-pointer">Escolher outra foto</p>
                </div>
            </div>
          </div>
        </div>
        <div
          class="
            dark:bg-gray-900
            bg-gray-50
            px-4
            py-3
            sm:px-6
            sm:flex sm:flex-row-reverse
          "
        >
          <button @click="handleImageCropped"
            type="button"
            class="
              w-full
              inline-flex
              justify-center
              rounded-md
              border border-transparent
              shadow-sm
              px-4
              py-2
              bg-indigo-600
              text-base
              font-medium
              text-white
              hover:bg-indigo-700
              focus:outline-none
              focus:ring-2 focus:ring-offset-2
              sm:ml-3
              sm:w-auto
              sm:text-sm
            "
          >
            Selecionar
          </button>
          <button
          @click="closeModal()"
            type="button"
            class="
              mt-3
              w-full
              inline-flex
              justify-center
              rounded-md
              border border-gray-300
              shadow-sm
              px-4
              py-2
              bg-white
              text-base
              font-medium
              text-gray-700
              hover:bg-gray-50
              focus:outline-none
              focus:ring-2 focus:ring-offset-2
              sm:mt-0
              sm:ml-3
              sm:w-auto
              sm:text-sm
            "
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cropper from 'cropperjs';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
import { onMounted, onUnmounted, ref, watch, watchEffect } from '@vue/runtime-core';

export default {
    name: 'ProfileCropper',
    components: { VueCropper},
    setup(_, { emit }) {
        const imageInput = ref(null); 
        const selectedFile = ref(null);
        const imageSrc = ref(null); 
        const fileReader = new FileReader()
        const img = ref(null)
        let cropper = null

        fileReader.onload = (e) => {
            imageSrc.value = e.target.result
        }

        const onChange = (e) => {
            const files = e.target.files || e.dataTransfer.files;
            if(files.length) {
                selectedFile.value = files[0]
            }
        }

        const clearFile = () => {
            selectedFile.value = null;
        }

        onMounted(() => {
            cropper = new Cropper(img.value, {
                aspectRatio: 1,
                minCropBoxWidth: 256,
                minCropBoxHeight: 256,
                viewMode: 3,
                dragMode: 'move',
                background: false,
                cropBoxMovable: false,
                cropBoxResizable: false,
            })
        })

        onUnmounted(() => {
          cropper.destroy();
        })

        watch(imageSrc, () => {
            if(imageSrc.value) {
                cropper.replace(imageSrc.value)
            }
        }, {flush: 'post'})

        watchEffect(() => {
            if(selectedFile.value) {
                fileReader.readAsDataURL(selectedFile.value)
            }else {
                imageSrc.value = null
            }
        })

        const handleImageCropped = () => {
          cropper
            .getCroppedCanvas({
              width: 256,
              height: 256,
            })
            .toBlob((blob) => {
              emit('imageCropped', blob)
            }, 'image/jpeg')

        }

        const closeModal = () => {
          emit('changeVisibility')
        }

        return {
            imageInput,
            selectedFile,
            onChange,
            imageSrc,
            img,
            handleImageCropped,
            clearFile,
            closeModal
        }
    }
};
</script>

<style>
</style>